'use client';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { Autoplay, EffectCoverflow, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import React from 'react';

const AutoSliderNeupos = ({ images }) => {
    return (
        <div className="w-full py-0">
            <div className="container mx-auto px-4">
                <Swiper
                    effect="coverflow"
                    grabCursor
                    centeredSlides
                    loop
                    slidesPerView="auto"
                    spaceBetween={100}
                    speed={600}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 40,
                        depth: 80,
                        modifier: 1.4,
                        slideShadows: false,
                    }}
                    pagination={{
                        clickable: true,
                        dynamicBullets: true,
                    }}
                    modules={[EffectCoverflow, Pagination, Autoplay]}
                    className="custom-swiper !pb-16"
                >
                    {images.map((img) => (
                        <SwiperSlide
                            key={img.id}
                            className="!w-[280px] sm:!w-[350px] md:!w-[450px] lg:!w-[550px] xl:!w-[650px]"
                        >
                            <div className="slide-image relative rounded-2xl overflow-hidden">
                                <img
                                    src={img.src || '/placeholder.svg'}
                                    alt={img.alt}
                                    className="w-full h-auto object-contain"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                {/* eslint-disable react/no-unknown-property */}
                <style jsx global>{`
                    .custom-swiper .swiper-slide {
                        padding: 0 12px;
                    }

                    .custom-swiper .slide-image {
                        transition:
                            filter 0.4s ease,
                            opacity 0.4s ease,
                            transform 0.4s ease;
                    }

                    /* Far slides */
                    .custom-swiper
                        .swiper-slide:not(.swiper-slide-active):not(
                            .swiper-slide-prev
                        ):not(.swiper-slide-next)
                        .slide-image {
                        filter: blur(2px);
                        transform: scale(0.94);
                    }

                    /* Adjacent slides */
                    .custom-swiper .swiper-slide-prev .slide-image,
                    .custom-swiper .swiper-slide-next .slide-image {
                        filter: blur(1px);
                        transform: scale(0.97);
                    }

                    /* Center slide */
                    .custom-swiper .swiper-slide-active .slide-image {
                        filter: blur(0);
                        transform: scale(1.05);
                    }

                    /* Move pagination dots down */
                    .custom-swiper .swiper-pagination {
                        bottom: 0 !important;
                    }

                    .custom-swiper .swiper-pagination-bullet {
                        background: #00b7fd;
                        opacity: 0.5;
                    }

                    .custom-swiper .swiper-pagination-bullet-active {
                        background: #00b7fd;
                        opacity: 1;
                    }
                `}</style>
                {/* eslint-enable react/no-unknown-property */}
            </div>
        </div>
    );
};

export default AutoSliderNeupos;
